<script>
import { mapActions, mapGetters } from "vuex";
export default {
  props: {
    content: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  methods: {
    ...mapActions(["toggleModal"]),
  },
  computed: {
    ...mapGetters(["watchVideo"]),
  },
};
</script>
<template>
  <div class="half-col">
    <h3 class="heading-3 vw-component-title">
      {{ content.title }}
    </h3>

    <p class="vw-component-content body-copy-1">
      <span v-html="content.copy"></span>

      <a
        v-if="typeof content.video !== 'undefined'"
        @click.prevent="toggleModal(content.video)"
        href="#"
        class="learnMore"
        >{{ watchVideo }}</a
      >
    </p>

    <ProductIndicator
      v-if="
        typeof content.products !== 'undefined' && content.products.length > 0
      "
      :active-products="content.products"
      class="vw-component-indicator"
    />
    <AppResponsiveImage :src="content.image" />
  </div>
</template>

<style lang="scss" scoped>
@import "../styles/01-settings/breakpoints";
@import "../styles/01-settings/mq";
.half-col {
  display: flex;
  flex-direction: column;
  text-align: center;
  --img-bottom-spacing: 50px;
}
.vw-component {
  padding-bottom: 0 !important;
}
.vw-component-indicator {
  margin-bottom: var(--img-bottom-spacing);
}
img {
  width: 100%;
  aspect-ratio: 1/1;
  object-fit: cover;
  margin-top: auto;
}
@include mq($from: md) {
  .half-col,
  .vw-component-title,
  .vw-component-content {
    text-align: left;
  }
  .vw-component-indicator {
    margin-left: 0;
    margin-bottom: var(--img-bottom-spacing);
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/vuejs/frontend/2023-launch/components/AppHalfCol.vue